/**
 * Push notification templates — bilingual (FR + EN priority, other locales
 * fall back to FR on the server side). Loaded by the admin from a dropdown
 * in PushBroadcastTab.jsx so recurring notices don't need re-typing.
 *
 * Each template contains at minimum {fr, en, it, es, de} — the remaining
 * 6 locales fall back to fr via the send_broadcast() cascade.
 */
export const PUSH_TEMPLATES = [
  {
    key: "sunday_mass",
    label_fr: "Rappel de messe dominicale",
    label_en: "Sunday mass reminder",
    deep_link: "/evenements",
    payloads: {
      fr: {
        title: "Messe dominicale",
        body: "Ce dimanche à 10h30 au Prieuré. À votre pas, dans la paix.",
      },
      en: {
        title: "Sunday mass",
        body: "This Sunday at 10:30 at the Priory. At your pace, in peace.",
      },
      it: {
        title: "Messa domenicale",
        body: "Questa domenica alle 10:30 al Priorato. Al Suo passo, nella pace.",
      },
      es: {
        title: "Misa dominical",
        body: "Este domingo a las 10:30 en el Priorato. A su paso, en paz.",
      },
      de: {
        title: "Sonntagsmesse",
        body: "Diesen Sonntag um 10:30 im Priorat. In Ihrem Tempo, im Frieden.",
      },
    },
  },
  {
    key: "concert",
    label_fr: "Annonce d'un concert",
    label_en: "Concert announcement",
    deep_link: "/evenements",
    payloads: {
      fr: {
        title: "Nouveau concert au Prieuré",
        body: "Un concert exceptionnel se prépare. Découvrez la programmation.",
      },
      en: {
        title: "New concert at the Priory",
        body: "An exceptional concert is being prepared. Discover the programme.",
      },
      it: {
        title: "Nuovo concerto al Priorato",
        body: "Un concerto eccezionale in preparazione. Scopri il programma.",
      },
      es: {
        title: "Nuevo concierto en el Priorato",
        body: "Se prepara un concierto excepcional. Descubra el programa.",
      },
      de: {
        title: "Neues Konzert im Priorat",
        body: "Ein außergewöhnliches Konzert wird vorbereitet. Entdecken Sie das Programm.",
      },
    },
  },
  {
    key: "ticket_open",
    label_fr: "Ouverture de billetterie",
    label_en: "Ticketing now open",
    deep_link: "/evenements",
    payloads: {
      fr: {
        title: "La billetterie est ouverte",
        body: "Les places sont désormais disponibles. Réservez la vôtre.",
      },
      en: {
        title: "Tickets are now available",
        body: "Seats are open for booking. Reserve yours.",
      },
      it: {
        title: "Biglietti disponibili",
        body: "Posti aperti alla prenotazione. Riservi il Suo.",
      },
      es: {
        title: "Entradas disponibles",
        body: "Las plazas están abiertas a reserva. Reserve la suya.",
      },
      de: {
        title: "Tickets sind verfügbar",
        body: "Die Plätze sind buchbar. Reservieren Sie den Ihren.",
      },
    },
  },
  {
    key: "thanks_event",
    label_fr: "Remerciement après un événement",
    label_en: "Thank you after an event",
    deep_link: "/",
    payloads: {
      fr: {
        title: "Un mot de gratitude",
        body: "Merci d'avoir partagé ce moment avec nous. Votre présence a compté.",
      },
      en: {
        title: "A word of thanks",
        body: "Thank you for sharing this moment with us. Your presence mattered.",
      },
      it: {
        title: "Una parola di gratitudine",
        body: "Grazie per aver condiviso questo momento con noi. La Sua presenza ha contato.",
      },
      es: {
        title: "Una palabra de gratitud",
        body: "Gracias por compartir este momento con nosotros. Su presencia contó.",
      },
      de: {
        title: "Ein Wort des Dankes",
        body: "Danke, dass Sie diesen Moment mit uns geteilt haben. Ihre Anwesenheit hat gezählt.",
      },
    },
  },
  {
    key: "daily_thought",
    label_fr: "Pensée du jour",
    label_en: "Daily thought",
    deep_link: "/actualites",
    payloads: {
      fr: {
        title: "Pensée du jour",
        body: "\"La paix commence par un souffle attentif.\" — Prenez un instant.",
      },
      en: {
        title: "Thought of the day",
        body: "\"Peace begins with an attentive breath.\" — Take a moment.",
      },
      it: {
        title: "Pensiero del giorno",
        body: "\"La pace comincia con un respiro attento.\" — Si prenda un istante.",
      },
      es: {
        title: "Pensamiento del día",
        body: "\"La paz comienza con un aliento atento.\" — Tómese un instante.",
      },
      de: {
        title: "Gedanke des Tages",
        body: "\"Frieden beginnt mit einem achtsamen Atemzug.\" — Nehmen Sie sich einen Moment.",
      },
    },
  },
];
